// repository of app-wide domain constants
export default {
    SUPPORT_EMAIL: 'hello@adaya.ai',

    DEFAULT_LOGIN_ROUTE: '/overview',

    ANSWER_CLOUD_URL: 'https://answers.adaya.ai/',

    ACCESS_TOKEN: 'access_token',
    FACEBOOK_ACCESS_TOKEN: 'facebook_access_token',
    TOKEN_OVERRIDES: 'token_overrides',
    CURRENT_USER: 'current_user',
    USE_MOCK_KEYS: 'use_mock_keys',

    USERPREF_TRACKING_COLS: 'userpref_tracking_cols',
    EXCHANGE_RATES: 'exchange_rates',
    APP_VERSION: 'app_version',
    USER_JOURNEYS_FILTER: 'user_journeys_filter',
    UTM_NONE: '(none)',
    ACCOUNT_CAMPAIGN_LIST: 'account_campaign_list',

    DISABLE_APP_VERSION_ALERTS: 'disable_app_version_alerts'
};
